import { groupBy, orderBy } from 'lodash-es'
import { action, computed, makeObservable, toJS } from 'mobx'
import type ExtendedMap from 'src/models/ExtendedMap'

import type { Sms } from './Sms'

export class SmsCollection {
  constructor(private smsMap: ExtendedMap<Sms['id'], Sms>) {
    makeObservable(this, {
      toArr: computed,
      toGrouped: computed,
      isEmpty: action,
    })
  }

  get toArr() {
    return [...this.smsMap.values()]
  }

  get toGrouped(): { date: string; messages: Sms[] }[] {
    const grouped = groupBy(toJS(this.toArr), (data) => data.sendDate) as {
      [key: string]: Sms[]
    }

    const arr: { date: string; messages: Sms[] }[] = []
    for (const date in grouped) {
      const d = grouped[date]
      arr.push({
        date: d[0].sendDate,
        messages: d,
      })
    }

    const result = orderBy(arr, [(data) => data.date], ['desc'])
    return result
  }

  isEmpty = () => {
    return this.smsMap.isEmpty
  }

  adds(smsColl: SmsCollection) {
    this.smsMap.adds(smsColl.smsMap.entries())
  }
}
